//
// Flight UI component for tracking when listings are in the viewport
//

import { component as defineComponent } from 'flightjs';
import trackEvent from '@99designs/utils/platform/trackEvent';

function inViewportTracker() {

    this.attributes({
        trackableElements: '[data-in-viewport-tracker-element]',
        listingId: 'data-in-viewport-tracker-element-id'
    });

    this.after('initialize', function() {
        this.trackedListings = [];
        this.intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                this.track(entry.target);
            });
        });

        const trackableNodes = Array.from(document.querySelectorAll(this.attr.trackableElements));

        trackableNodes.forEach((node) => {
            this.intersectionObserver.observe(node);
        });
    });

    this.track = function(element) {
        const listingId = element.dataset.inViewportTrackerElementId;
        if (!this.trackedListings.includes(listingId)) {
            trackEvent('Viewed Contest Listing', {
                listingId: listingId
            });
            this.trackedListings.push(listingId);
        }
    }

    this.teardown = function() {
        this.intersectionObserver.disconnect();
    }
}

export default defineComponent(inViewportTracker);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/in-viewport-tracker.js